// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1ce84d68","952":"30d26baa"}[chunkId] + ".chunk.js";
};